
    const monthlyBtnElements = document.querySelectorAll(".brave-plus__monthly-only");
    const monthCartDrawer = (sections) => {
      let cartDrawerEl = document.querySelector("#CartDrawer");
      let html = new DOMParser()
        .parseFromString(sections["cart-drawer"], "text/html")
        .querySelector("#CartDrawer").innerHTML;
      cartDrawerEl.innerHTML = html;
      let bubbleEl = document.querySelector("#cart-icon-bubble");
      bubbleEl.innerHTML = sections["cart-icon-bubble"];
    };
    const monthlyAtc = (e) => {
      e.target.innerHTML = "Adding...";
      $.ajax({
        type: "POST",
        url: "/cart/add",
        dataType: "json",
        data: {
          items: [
            {
              quantity: 1,
              id: 46103323050242,
              selling_plan: 3209822466,
              form_type: "product",
            },
          ],
          sections: "cart-drawer,cart-icon-bubble",
        },
        success: async function (res) {
          e.target.innerHTML = "Added";
          e.target.removeAttribute("disabled", "");
          monthCartDrawer(res.sections);
          setTimeout(() => {
            document
              .querySelector("#cartDrawerContainer")
              .classList.add("active");
          }, 500);
        },
      }).fail(function (e) {
        e.target.innerHTML = "Added";
      });
    };
    for (let btnEl of monthlyBtnElements) {
      btnEl.addEventListener('click', monthlyAtc);
    }